import { noop } from 'lodash'
import { FC, useState } from 'react'
import { HashRouter } from 'react-router-dom'
import { NavigationConfirmationContext } from './NavigationConfirmation'

const DEFAULT_NAV_PROMPT = { isActive: false, callback: noop }

export const ConeRouter: FC = ({ children = null }) => {
  const [navPrompt, setNavPrompt] = useState<$TSFIXME>(DEFAULT_NAV_PROMPT)
  return (
    <NavigationConfirmationContext.Provider value={navPrompt}>
      <HashRouter
        getUserConfirmation={(message, callback) =>
          setNavPrompt({
            isActive: true,
            callback(ok: $TSFIXME) {
              setNavPrompt(DEFAULT_NAV_PROMPT)
              callback(ok)
            },
          })
        }
      >
        {children}
      </HashRouter>
    </NavigationConfirmationContext.Provider>
  )
}
